(ns app.domain.bim.attachment-model
  (:require [app.domain.group.model :as group-model]
            [core.db.child-entity :as child]))

(def types
  [:bim-attachment.type/architectural
   :bim-attachment.type/structural
   :bim-attachment.type/mep])

(defmethod group-model/get-authority-group :entity.type/bim-attachment
  [attachment]
  (-> attachment :entity/parent group-model/get-authority-group))

(defmethod group-model/get-authority-group :entity.type/bim-attachment-version
  [attachment-version]
  (-> attachment-version :entity/parent group-model/get-authority-group))

(def ^{:arglists '([phase-entity])} phase-bim-attachments
  (child/child-entities-of-type-fn :entity.type/bim-attachment))

(def ^{:arglists '([bim-attachment])} versions
  (child/child-entities-of-type-fn :entity.type/bim-attachment-version))

(defn latest-version [bim-attachment]
  (->> (versions bim-attachment)
       (sort-by :entity/created)
       last))

(defn attachment-workspace [bim-attachment]
  (-> bim-attachment
      :entity/parent
      :entity/parent))

(defn version-workspace [bim-attachment-version]
  (-> bim-attachment-version
      :entity/parent
      attachment-workspace))

(defn validation-state [bim-attachment]
  (-> bim-attachment latest-version :bim-attachment-version/validation-state))

(defn compliance-state [bim-attachment]
  (-> bim-attachment latest-version :bim-attachment-version/compliance-state))

(defn compliance-checked? [bim-attachment-version]
  (->> bim-attachment-version
       :bim-attachment-version/compliance-state
       (contains? #{:bim-attachment-version.compliance-state/valid
                    :bim-attachment-version.compliance-state/invalid})))
